import { useContext } from 'react';
import { ReactConsentContext } from '../../Flow/ConsentContextProvider';

// Renders hidden form fields specific to the TWG consent flow.
// selectedScopes reflects what was shown to the user: filteredScopes from
// /consent/info when present, otherwise the full set from the context token.
// selectedOrg is submitted when the user has selected an organization.
const TwgFlowParameters = () => {
  const context = useContext(ReactConsentContext);

  if (!context) {
    throw new Error('TwgFlowParameters must be used within ConsentContextProvider');
  }

  const { token, info, selectedOrg, selectedScopes: userSelectedScopes } = context;
  // Undefined means org info has not initialized user selection yet. An empty array
  // is an intentional all-deselect and must submit as an empty value.
  const selectedScopes = (userSelectedScopes ?? (info.filteredScopes ?? token.scopes)).join(' ');

  return (
    <>
      <input type="hidden" name="selectedScopes" value={selectedScopes} />
      {selectedOrg && <input type="hidden" name="selectedOrg" value={selectedOrg} />}
    </>
  );
};

export default TwgFlowParameters;
